// extracted by mini-css-extract-plugin
export default {"side-bar":"side-bar_side-bar__Rb7T7"};